var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMiddleStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 32,
    viewBox: "0 0 68 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33289 1.37634C0.985361 1.07235 1.20036 0.5 1.66208 0.5H60C60.363 0.5 60.714 0.631819 60.988 0.870979L67.5 16L60.988 31.129C60.714 31.3682 60.363 31.5 60 31.5H1.66207C1.20036 31.5 0.985352 30.9277 1.33289 30.6237L8 16L1.33289 1.37634Z",
    stroke: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMiddleStepIcon);
export default __webpack_public_path__ + "static/media/mobile-middle-step-icon.93e64774c0eb2a357352452cee13cae5.svg";
export { ForwardRef as ReactComponent };